import axios from "axios";
import { storage } from "../../../helpers";
import { API_URL } from "../../../config";

export const exportDocumentZIPRequest = async (id, forModal = false) => {
    const token = storage.getToken();

    try {
        const response = await axios.get(`${API_URL}/documents/${id}/zip`, {
            responseType: "arraybuffer",
            headers: {
                Accept: "application/zip",
                Authorization: `Bearer ${token}`,
            },
        });

        if (forModal) {
            console.log("Returning ZIP data for modal");
            return response.data;
        } else {
            const blob = new Blob([response.data], { type: "application/zip" });

            const contentDisposition = response.headers['content-disposition'];
            const fileNameMatch = contentDisposition?.match(/filename="(.+?)"/);
            const fileName = fileNameMatch ? fileNameMatch[1] : `Document_${id}.zip`;

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.click();

            window.URL.revokeObjectURL(url);

            console.log("ZIP downloaded successfully");
        }
    } catch (error) {
        console.error("Error fetching ZIP:", error);
        throw error;
    }
};
